<template>
  <nav class="navbar navbar-expand-lg custom-navbar">
    <div class="container-fluid">
      <!-- Logo -->
      <a href="https://stratayourself.com.au/" class="navbar-brand">
        <img
          src="/assets/imagesLanding/new-logo.png"
          alt="DIY Strata Management"
          class="logo-img"
        />
      </a>

      <!-- Mobile toggle -->
      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarSupportedContent"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <!-- Menu -->
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav ms-auto align-items-lg-center">
          <li class="nav-item">
            <a class="nav-link" href="https://stratayourself.com.au/features/">
              Features
            </a>
          </li>

          <li class="nav-item">
            <a class="nav-link" href="/pricing"> Pricing </a>
          </li>

          <li class="nav-item">
            <a class="nav-link" href="https://stratayourself.com.au/about-us/">
              About Us
            </a>
          </li>

          <li class="nav-item dropdown">
            <a
              class="nav-link dropdown-toggle"
              href="#"
              id="articlesDropdown"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              Articles
            </a>
            <ul class="dropdown-menu" aria-labelledby="articlesDropdown">
              <li>
                <a class="dropdown-item" href="https://stratayourself.com.au/how-to-self-manage-a-strata-scheme-in-australia/">
                  How to Self-Manage a Strata<br>Scheme in Australia
                </a>
              </li>
              <li>
                <a class="dropdown-item" href="https://stratayourself.com.au/top-10-self-managed-strata-mistakes-to-avoid/">
                  Top 10 Self-Managed Strata Mistakes<br>to Avoid
                </a>
              </li>
              <li>
                <a class="dropdown-item" href="https://stratayourself.com.au/duties-of-a-self-managed-owners-corporation/">
                  Duties of a Self-Managed Owners<br>Corporation
                </a>
              </li>
              <li>
                <a class="dropdown-item" href="https://stratayourself.com.au/how-to-run-a-strata-agm-and-keep-minutes/">
                  How to Run a Strata AGM and Keep<br>Minutes
                </a>
              </li>
              <li>
                <a class="dropdown-item" href="https://stratayourself.com.au/how-to-set-issue-and-collect-strata-levies/">
                  How to Set, Issue and Collect Strata<br>Levies
                </a>
              </li>
              <li>
                <a class="dropdown-item" href="https://stratayourself.com.au/self-managed-strata-vs-strata-manager/">
                  Self-Managed Strata vs Strata<br>Manager
                </a>
              </li>
            </ul>
          </li>

          <li class="nav-item">
            <a
              class="nav-link"
              href="https://stratayourself.com.au/how-to-switch/"
            >
              How to Switch
            </a>
          </li>

          <li class="nav-item">
            <a class="nav-link" href="https://stratayourself.com.au/resources/">
              Resources
            </a>
          </li>

          <li class="nav-item">
            <a class="nav-link" href="https://stratayourself.com.au/faq/">
              FAQ
            </a>
          </li>

          <li
            v-if="checkSuperAdmin != null"
            @click="backToSuperAdmin()"
            class="btn get-started-btn"
          >
            Back to Super Admin
          </li>

          <!-- Login / Logout -->
          <li v-else class="nav-item ms-lg-3">
            <!-- Login -->

            <router-link
              v-if="!isLoggedIn"
              class="btn get-started-btn"
              to="/login"
            >
              Get Started
            </router-link>

            <!-- Logout -->
            <button
              v-else
              class="btn get-started-btn d-flex align-items-center gap-2"
              @click="logout"
              :disabled="loader"
            >
              <span v-if="!loader">Logout</span>
              <loader v-else />
            </button>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import loader from "../loader.vue";

export default {
  name: "HeaderPage",
  components: { loader },

  data() {
    return { loader: false, checkSuperAdmin: "", checkAdmin: "" };
  },

  created() {
    this.checkSuperAdmin = localStorage.getItem("superAdminToken");
    this.checkAdmin = localStorage.getItem("adminToken");
  },

  computed: {
    isLoggedIn() {
      return !!localStorage.getItem("token");
    },
  },

  methods: {
    logout() {
      this.loader = true;
      this.$store
        .dispatch("logout", {
          userToken: localStorage.getItem("token"),
          name: "admin",
        })
        .finally(() => {
          this.loader = false;
        });
    },
    backToSuperAdmin() {
      this.loaderSuperAdmin = true;
      // return
      this.$store
        .dispatch("BackToSuperAdmin")
        .then(() => {
          this.loaderSuperAdmin = false;
          localStorage.removeItem("adminToken");
        })
        .catch(() => {
          this.loaderSuperAdmin = false;
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped src="../../../public/assets/cssLanding/bootstrap.min.css"></style>
<style scoped src="../../../public/assets/fontsLanding/iconfonts.css"></style>
<style scoped src="../../../public/assets/cssLanding/plugins.css"></style>
<style scoped src="../../../public/assets/cssLanding/style.css"></style>
<style scoped src="../../../public/assets/cssLanding/responsive.css"></style>
<style scoped src="../../../public/assets/cssLanding/color.css"></style>
<style scoped>
/* Navbar wrapper */
.navbar {
  padding: 0px 130px !important;
}

.custom-navbar {
  background: #ffffff;
  padding: 34px 80px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
}

/* Logo */
.logo-img {
  width: 87%;
  max-width: 200px;
  height: auto;
}

/* Menu links */
.nav-link {
  color: #333333 !important;
  font-size: 16px;
  font-weight: 500;
  padding: 0 0px !important;
  transition: color 0.3s ease;
  margin-right:20px;
}

.nav-link:hover {
  color: #605be5 !important;
  border-bottom: 2px solid #605be5;
}

/* Articles dropdown */
.dropdown-toggle::after {
  display: inline-block;
  vertical-align: middle;
  margin-left: 6px;
  content: "";
  border-top: 6px solid;
  border-right: 5px solid transparent;
  border-left: 5px solid transparent;
  border-bottom: 0;
}

.dropdown-toggle.show,
.dropdown:hover .dropdown-toggle {
  color: #605be5 !important;
}

.dropdown-menu {
  width: 300px;
  max-width: 90vw;
  padding: 0;
  border: none;
  border-radius: 10px;
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.12);
  overflow: hidden;
  margin-top: 12px;
}

.dropdown-item {
  padding: 22px 22px;
  font-size: 15px;
  font-weight: 500;
  color: #333333;
  white-space: normal;
  line-height: 1.4;
  border-bottom: 1px solid #eef0f2;
  transition: background-color 0.2s ease, color 0.2s ease;
}

.dropdown-menu li:last-child .dropdown-item {
  border-bottom: none;
}

.dropdown-item:hover,
.dropdown-item:focus {
  background-color: #605be5;
  color: #ffffff;
  font-weight: 700;
}

/* Get Started Button */
.get-started-btn {
  background-color: #2f8f57;
  color: #ffffff !important;
  padding: 10px 22px;
  border-radius: 10px;
  font-weight: 600;
  transition: all 0.3s ease;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.38);
}

.get-started-btn:hover {
  background-color: #257446;
}

/* Mobile */
@media (max-width: 768px) {
  .custom-navbar {
    padding: 20px;
  }

  .get-started-btn {
    margin-top: 15px;
    width: 100%;
    text-align: center;
  }
}
</style>
